import { CountUp } from 'countup.js';
import { wrapString } from '../utils/wrappers';

// const numberRegex = /(?:\d{1,3}[.,:]?)+\d*/;
const numberRegex = /(\d+)[:,.]?(\d+)/;

/**
 * @description
 * Set class or id with "counter" keyword in it on mod_article.
 * Script is going to automatically find and pack up the numbers inside span.number element.
 *
 * @param {string} countersSelector - you can override the default selector, which is - '[class*="counter"], [id*="counter"]'
 * @param {string} numbersSelector - selector into element with number, default - 'p:first-child'
 * @param {CountUpOptions} countUpOptions - options for CountUp script - https://github.com/inorganik/countUp.js
 *
 * @example
 * <div.mod_article.counters>
 *      [...]
 *          <div.text_container>
 *              <p>2000 KwH</p>
 *          </div.text_container>
 *      [...]
 * </div.mod_article.counters>
 */
function countUp(
    resetOnlyFromTop = true,
    countUpOptions = {},
    countersSelector = '[class*="counter"], [id*="counter"]',
    numbersSelector = 'p'
) {
    let options = Object.assign({ separator: '.', enableScrollSpy: resetOnlyFromTop ? false : true }, countUpOptions);

    let sectionsWithCounters = document.querySelectorAll(countersSelector);

    sectionsWithCounters.forEach(function (section) {
        let pWithNumbers = section.querySelectorAll(numbersSelector);

        let elementsWithNumbers = [...pWithNumbers].filter((el) => numberRegex.test(el.innerText));

        elementsWithNumbers.forEach((elementWithNumber) => {
            createCounter(elementWithNumber, { ...options });
        });
    });
}

function createCounter(elementWithNumber, options) {
    let finalNumber = elementWithNumber.innerHTML.match(numberRegex);
    if (elementWithNumber.innerHTML.indexOf(':') > -1) {
        for (let i = 1; i < finalNumber.length; i++) {
            elementWithNumber.innerHTML = elementWithNumber.innerHTML.replace(
                finalNumber[i],
                wrapString(finalNumber[i], 'span', {
                    class: 'countUp_number' + i,
                })
            );
        }

        for (let i = 1; i < finalNumber.length; i++) {
            _initCountUp(elementWithNumber, finalNumber[i], options, i);
        }
    } else {
        elementWithNumber.innerHTML = elementWithNumber.innerHTML.replace(
            finalNumber[0],
            wrapString(finalNumber[0], 'span', {
                class: 'countUp_number',
            })
        );
        _initCountUp(elementWithNumber, finalNumber[0], options);
    }
}

function _initCountUp(elementWithNumber, finalNumber, options, index = null) {
    // elementWithNumber.innerHTML = elementWithNumber.innerHTML.replace(
    //     finalNumber,
    //     wrapString(finalNumber, 'span', {
    //         class: index == null ? 'countUp_number' : 'countUp_number' + index,
    //     })
    // );

    finalNumber = finalNumber.replaceAll(/[.,:]/g, '');

    let numberSpan = elementWithNumber.querySelector('span.countUp_number' + (index ?? ''));

    if (finalNumber.startsWith('0') && finalNumber.length > 1) {
        options.prefix = '0';
    } else {
        options.prefix = '';
    }

    let counter = new CountUp(numberSpan, finalNumber, options);

    if (!options.enableScrollSpy) appendOwnListeners(counter);
}

// Functions to make counters to be fired only if scrolled from top

function appendOwnListeners(counter) {
    counter.paused = false;

    window.addEventListener('scroll', setScrollListenerEvent);

    window.addEventListener('resize', function () {
        // positions = calculateNewPositions(counter.el);
        window.removeEventListener('scroll', setScrollListenerEvent);
        window.addEventListener('scroll', setScrollListenerEvent);
    });

    function setScrollListenerEvent() {
        countUpOnScroll(counter);
    }

    /**
     * @param {CountUp} counter
     */
    function countUpOnScroll(counter) {
        const bottomOfScroll = window.innerHeight + window.scrollY;
        const rect = counter.el.getBoundingClientRect();

        const topOfEl = rect.top + window.scrollY;
        const bottomOfEl = rect.top + rect.height + window.scrollY;

        if (bottomOfEl < bottomOfScroll && bottomOfEl > window.scrollY && !counter.paused) {
            // in view
            counter.start();
            counter.paused = true;
        } else if (topOfEl > bottomOfScroll && counter.paused) {
            counter.reset();
            counter.paused = false;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    countUp(true, {}, '.counters', 'p');
    countUp(true, {}, '[class^="counter"]', '.distance');
    countUp(true, {}, '[class^="counter"]', '.arrival_time');
    // countUp(true, {}, '[class^="counter"]', '.arrival_time');
});
